<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol xs="12" sm="6" md="4" lg="4" xl="2">
        <div class="form-group">
          <label for="datepicker">Từ ngày - đến ngày</label>
          <DatePicker id="datepicker" locale="vi" v-model="dateRange" :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" :popover="{ visibility: 'click' }" is-range
                      class="datepicker">
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="inputValue.start + ' - ' + inputValue.end"
                v-on="inputEvents.start"
                class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                readonly
              />
            </template>
          </DatePicker>
        </div>
      </CCol>
      <CCol xs="12" sm="6" md="4" lg="4" xl="2">
        <BaseInput
          :options="userNameInput.options"
          :data="userNameInput.data"
          :listener="userNameInput.listener"
        />
      </CCol>
      <CCol>
        <div class="form-group">
          <label style="color: white"></label>
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #index="{index}">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #timeAction="{item}">
            <td v-if="item.timeAction != null">
              {{ $helper.formatDateDDMMYYYYHHMM(item.timeAction) }}
            </td>
            <td v-if="item.timeAction == null">

            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
  </div>
</template>

<script>
import {DatePicker} from "v-calendar";
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2"

export default {
  name: "UserActionLogList",
  components: {
    DatePicker,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    return {
      dateRange: {
        start: this.$helper.subtractNowDate(10),
        end: new Date()
      },
      userNameInput: {
        options: {
          placeholder: "Người thao tác",
          label: 'Người thao tác'
        },
        data: {
          name: "userNameSearch",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      mainTable: {
        options: {
          fields: [
            // {key: "checkbox", label: "#"},
            {key: "index", label: "STT", sorter: false, filter: false},
            {key: "nameAction", label: "Hoạt động"},
            {key: "userName", label: "Người thao tác"},
            {key: "ipAction", label: "Địa chỉ IP"},
            {key: "timeAction", label: "Thời gian thao tác"},
          ],
          slots: ["index", "timeAction"],
          pageSize: 20,
          sorter: true,
          columnFilter: false,
          clickableRows: true,
        },
        dataSource: {
          url: "/common/listActivityLog",
          dataSubmit: function () {
            return {
              fromDate: that.$helper.formatDateDDMMYYYY(that.dateRange.start.getTime()),
              toDate: that.$helper.formatDateDDMMYYYY(that.dateRange.end.getTime()),
              userNameSearch: that.userNameInput.data.model
            }
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
  },
  created: function () {
  },
  mounted() {
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataMainTable();
      } else {
        this.dateRange = {
          start: new Date(),
          end: new Date()
        }
      }
    }
  },
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}
</style>
